<template>
  <div class="pb-6">
    <Typography variant="h-4" class="text-center"
      >First let's confirm the CSV column headers</Typography
    >
    <Typography variant="subtitle-1" class="text-center pb-6"
      >Match your file columns to the required fields
    </Typography>
    <MapCSVColumnsTable
      :rows="rows"
      :columns="columns"
      @mapped-csv-columns-updated="onMappedRowsChange"
      auto-map-columns
    />
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import MapCSVColumnsTable from "@/components/MapCSVColumnsTable.vue";
export default {
  name: "MapColumnsStep",
  components: {
    Typography,
    MapCSVColumnsTable,
  },
  props: {
    rows: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onMappedRowsChange(mappedRows) {
      this.$emit("mapped-csv-columns-updated", mappedRows);
    },
  },
};
</script>
